import { NTemplates } from "./types.Templates";

export const baseTemplatesReducer: NTemplates.Reducer = {
    list: [],
    templates: {}
};